import React from 'react';
import { getPromoTransactions } from '../../../../services/promoCodeService';
import PromoTransactions from './PromoTransactions';

const PromoTransactionsTab = () => {
  return (
    <PromoTransactions
      getTransactions={getPromoTransactions}
      type="withoutCode"
    />
  );
};

export default PromoTransactionsTab;
